import axios from "axios";
import { aswoToModelVariant, connectToModelVariant, illustrationsToFiles } from '../models/modelConverter'
import { aswoToPart, connectToPart } from '../models/partConverter'
import { vueGsheets } from "vue-gsheets";
const AWSOAPIKEY = '509-10350-6da36b49ef06ce650b8daa6edfe881de';
const CONNECTAPIKEY = 'D654229B-49A6-4D8B-A372-A1B0FA1889DF'
const ASWOProvider = { code: "1100757010", name: "ASWO" }; //ASWO
const ConnectProvider = { code: "1100001235", name: "Connect" }; //Connect

const Providers = [ASWOProvider, ConnectProvider]

export async function providersToModelList(model) {
    const promiseList = []
    Providers.forEach(provider => {
        // console.log("Looking For", model);
        if (provider.name == "ASWO") { promiseList.push(getASWOModels(model)) }
        if (provider.name == "Connect") { promiseList.push(getConnectModels(model)) }

    })
    return await Promise.all(promiseList);
}

export async function providersToPartsList(part) {
    const promiseList = []
    Providers.forEach(provider => {
        // console.log("Looking For", part);
        if (provider.name == "ASWO") { promiseList.push(getASWOPartsFromPart(part)) }
        if (provider.name == "Connect") { promiseList.push(getConnectPartsFromPart(part)) }

    })
    return await Promise.all(promiseList);
}




// export async function getConnectModels(model) {
//     var config = {
//         method: 'get',
//         url: `${process.env.VUE_APP_CONNECT_PROXY}product/model?query=${model}`,
//         headers: {
//             'x-api-key': CONNECTAPIKEY
//         },

//     };
//     return axios(config)
//         .then(async function (response) {
//             const modelsList = response.data.models.flatMap(model => {

//                 return model.variants.flatMap(variant => {
//                     delete model.variants

//                     return connectToModelVariant({ ...model, ...variant })
//                 })

//             })
//             const modelsListWithTotalResult = await Promise.all(modelsList.map(async model => {
//                 model.totalResults = await connectGetTotalResults(model.modelId, model.variantId)
//                 return model
//             }))
//             // console.log(
//             //     modelsListWithTotalResult)

//             //
//             return modelsListWithTotalResult
//         })
//         .catch(function (error) {
//             console.log(error);
//             return error
//         });

// }

export async function getConnectModels(model) {
    var config = {
        method: 'get',
        url: `${process.env.VUE_APP_CONNECT_PROXY}product/model?query=${model}`,
        headers: {
            'x-api-key': CONNECTAPIKEY
        },

    };
    return axios(config)
        .then(async function (response) {
            const modelsList = response.data.models.flatMap(model => {

                return model.variants.flatMap(variant => {
                    delete model.variants
                    // console.log(variant);
                    return connectToModelVariant({ ...model, ...variant })
                })

            })
            const modelsListWithTotalResult = await Promise.all(modelsList.map(async model => {
                // model.totalResults = model.variants.totalItems
                // console.log(model);
                return model
            }))
            // console.log(
            //     modelsListWithTotalResult)

            // 
            return modelsListWithTotalResult
        })
        .catch(function (error) {
            console.log(error);
            return error
        });

}




export async function getASWOModels(model) {
    var config = {
        method: 'get',
        url: `${process.env.VUE_APP_ASWO_PROXY}devicesearch?devicesearchkeywords=${model}&apikey=${AWSOAPIKEY}&format=JSON`,

    };
    return axios(config)
        .then(function (response) {
            const models = Object.values(response.data).map(model => aswoToModelVariant(model));
            //add files model.files = await getASWOFiles(model.modelId)
            return models
        })
        .catch(function (error) {
            console.log(error);
            return []
        });

}

export async function connectGetTotalResults(modelId, variantId) {
    var config = {
        method: 'get',
        url: `${process.env.VUE_APP_CONNECT_PROXY}product/model/${modelId}/variant/${variantId}`,
        headers: {
            'x-api-key': CONNECTAPIKEY
        }, params: {
            itemRows: 1

        }
    };
    return axios(config)
        .then(function (response) {
            const data = response.data
            return data.totalResults;
        })
        .catch(function (error) {
            console.log(error);
            return []
        });

}


export async function getConnectModelVarients(modelId, variantId, itemStart = 0) {
    var config = {
        method: 'get',
        url: `${process.env.VUE_APP_CONNECT_PROXY}product/model/${modelId}/variant/${variantId}`,
        headers: {
            'x-api-key': CONNECTAPIKEY
        }, params: {
            itemRows: 20,
            itemStart, itemStart
        }
    };
    return axios(config)
        .then(async function (response) {
            const data = response.data
            // console.log(data.totalResults);

            if (data.totalResults > 20) {
                const pagesCompleted = []
                const pages = Math.ceil(data.totalResults / 20)
                let page = 0
                while (page < pages) {
                    page += 1;
                    // console.log(page);
                    pagesCompleted.push(getEachPageConnect(modelId, variantId, itemStart = page * 20));
                }
                // data.items.add(...await Promise.all(pagesCompleted))
                // console.log(...await Promise.all(pagesCompleted))
                data.items = data.items.concat
                    .apply(data.items.map(part => connectToPart(part)), await Promise.all(pagesCompleted))

                return { files: illustrationsToFiles(data.illustrations), items: data.items };
            } else {

                return { files: illustrationsToFiles(data.illustrations), items: data.items.map(part => connectToPart(part)) };
            }
        })
        .catch(function (error) {
            console.log(error);
            return []
        });

}
async function getEachPageConnect(modelId, variantId, itemStart = 0) {
    var config = {
        method: 'get',
        url: `${process.env.VUE_APP_CONNECT_PROXY}product/model/${modelId}/variant/${variantId}`,
        headers: {
            'x-api-key': CONNECTAPIKEY
        }, params: {
            itemRows: 20,
            itemStart, itemStart
        }
    };
    return axios(config)
        .then(function (response) {
            const data = response.data
            return data.items.map(part => connectToPart(part));
        })
        .catch(function (error) {
            console.log(error);
            return []
        });

}
export async function getASWOModelVarients(varientId) {
    var config = {
        method: 'get',
        url: `${process.env.VUE_APP_ASWO_PROXY}articlesearch?articlesearchkeywords=${varientId}&apikey=${AWSOAPIKEY}&format=JSON`,

    };
    return axios(config)
        .then(function (response) {
            return response.data;
            getASWOFiles(varientId)
        })
        .catch(function (error) {
            console.log(error);
            return []
        });

}


export async function getSeviceNetParts(Item) {
    const url = process.env.VUE_APP_PROXY + "devicearticles";
    return await axios.get(url, {
        withCredentials: false,
        auth: {
            username: "Tecnico",
            password: "Master"
        },
        headers: {
            "postman-token": "513705db-790d-ead9-bab6-7f1b682583c6",
            "cache-control": "no-cache",
            "Content-type": "Application/json"
        },
        params: {
            deviceid: Item.Geraeteid,
            format: "JSON",
            apikey: "509-10350-6da36b49ef06ce650b8daa6edfe881de",
            providerid: Item.supplier.code,
            articlesearchterm: " "
        }
    });

}


export async function getAltParts(part) {

    var config = {
        method: 'get',
        url: `https://us-central1-whirlpool-multibrand.cloudfunctions.net/webApi/api/v1/part/${part.partNumber}`,
        headers: {

            authorization: 'VlRGb1UxUlhTWGxhU0VKcFdub3dPUT09'
        },

    };

    return await axios(config).then((onfulfilled, onRejected) => {


        if (onfulfilled.data != undefined) {
            // const objectKey = Object.keys(onfulfilled.data)[0]

            // const part = objectKeys.map(keys => onfulfilled.data[keys])

            if (onfulfilled.data !== "No such document!") {

                const objectKeys = Object.keys(onfulfilled.data)
                console.log(objectKeys);
                const part = objectKeys.map(keys => onfulfilled.data[keys])

                return part[0].alternative;
                // const dnumber = part[0] !=undefined ? part[0].alternative.startWith("C") : false
                // if (!dnumber) {
                //     console.log("Has D");
                //     return part.find(partactive => partactive.active).alternative
                // } else {
                //     console.log("Has C");

                //   return  part[0].alternative
                //             }

            }
            //         console.log("no", onfulfilled.data);
            //         return ""
        }
        return ""
        // return onfulfilled.data[objectKey].alternative ? onfulfilled.data[objectKey].alternative : ""

    })
        .catch(err => {
            console.warn(err.response.data ? err.response.data?.status : err.response.status);;

            return ""
        })
}


export async function getPartFromDNumber(part) {

    var config = {
        method: 'get',
        url: `https://us-central1-whirlpool-multibrand.cloudfunctions.net/webApi/api/v1/getd/${part}`,
        headers: {
            authorization: 'VlRGb1UxUlhTWGxhU0VKcFdub3dPUT09'
        },

    };

    return await axios(config).then((onfulfilled, onRejected) => {
        // console.log(onfulfilled);
        // const objectKey = Object.keys(onfulfilled.data)[0]
        // console.log(onfulfilled.data[objectKey].alternative);

        return onfulfilled.data.partnumber ? onfulfilled.data.partnumber : "No C or D Number"
    })
        .catch(err => {
            console.warn(err.response.data ? err.response.data?.status : err.response.status);;

            return err + "No C or D Number"
        })
}

export async function getConnectItemFromID(partnumber) {

    var config = {
        method: 'get',
        url: `${process.env.VUE_APP_CONNECT_PROXY}product/item/${partnumber}`,
        headers: {
            'x-api-key': CONNECTAPIKEY
        }
    };

    return axios(config)
        .then(function (response) {
            return response.data.alternatives.map(alt => { return connectToPart(alt) });
        })
        .catch(function (error) {
            console.log(error);
            return []
        });

}
export async function getConnectItemFromIDImages(partnumber) {

    var config = {
        method: 'get',
        url: `${process.env.VUE_APP_CONNECT_PROXY}product/item/${partnumber}`,
        headers: {
            'x-api-key': CONNECTAPIKEY
        }
    };

    return axios(config)
        .then(function (response) {
            return connectToPart(response.data)
        })
        .catch(function (error) {
            console.log(error);
            return []
        });

}
export async function getASWOAlternativesFromID(partnumber) {
    var config = {
        method: 'get',
        url: ` ${process.env.VUE_APP_ASWO_PROXY}articlesearch?vergleich=${partnumber}&apikey=${AWSOAPIKEY}&format=JSON`

    };

    return axios(config)
        .then(function (response) {
            return response.data;
        })
        .catch(function (error) {
            console.log(error);
            return []
        });

}
export async function getCPartFromServiceNet(part) {

    const partnumber = part.manufactureCode.trim()
    console.log(partnumber, partnumber.length);
    if (part && partnumber.length >= 9 && partnumber.length <= 10) {


        var config = {
            method: 'post',
            url: `https://us-central1-beko-net.cloudfunctions.net/getCPart`,
            headers: {
                authorization: 'VlRGb1UxUlhTWGxhU0VKcFdub3dPUT09'
            },
            data: { part: partnumber }
        };

        return await axios(config).then(async (onfulfilled, onRejected) => {
            console.log("fulfilled", await onfulfilled.data.spare_part_detail
            );
            // console.log(onRejected);
            // const objectKey = Object.keys(onfulfilled.data)[0]
            // console.log(onfulfilled.data[objectKey].alternative);

            return await onfulfilled.data.spare_part_detail.partNumber ? onfulfilled.data.spare_part_detail.partNumber : getAltParts(part)
        })
            .catch(err => {
                console.warn(err.response.data ? err.response.data?.status : err.response.status);;

                return getAltParts(part)
            })
    } else {
        return getAltParts(part)
    }
}


export async function getConnectItemFromManufatureCode(partnumber) {

    var config = {
        method: 'get',
        url: `${process.env.VUE_APP_CONNECT_PROXY}product/item?query=${partnumber}`,
        headers: {
            'x-api-key': CONNECTAPIKEY
        }
    };

    return axios(config)
        .then(function (response) {
            return response.data;
        })
        .catch(function (error) {
            console.log(error);
            return []
        });

}

export async function getASWOFiles(deviceId) {
    var config = {
        method: 'get',
        url: ` ${process.env.VUE_APP_ASWO_PROXY}devicefiles?deviceid=${deviceId}&format=JSON&apikey=${AWSOAPIKEY}`,
        headers: {}
    };

    return axios(config)
        .then(function (response) {

            console.log("ASWO GET FILE",);
            try {
                const filesObjectToArray = Object.keys(response.data).map(key => { return response.data[key] })
                const filesData = filesObjectToArray.map(file => { return { url: file.url, illustrationImage: file.thumbnailurl, title: file.dateiname, supplierName: "ASWO" } });

                console.log("ASWO GET FILE", filesData);

                return filesData
            } catch {
                return []
            }


        })
        .catch(function (error) {
            console.log(error);
            return error
        });
}

export async function getASWOPics(deviceId) {
    var config = {
        method: 'get',
        responseType: 'blob',
        url: ` ${process.env.VUE_APP_ASWO_PROXY}pic4article?artnr=${deviceId}&format=JSON&apikey=${AWSOAPIKEY}`,
        headers: {}
    };

    return axios(config)
        .then(function (response) {
            // console.log(response.data);
            try {
                return response.data
                // .map(file => { return { url: file.url, illustrationImage: file.thumbnailurl, title: file.dateiname, supplierName: "ASWO" } });
            } catch {
                return []
            }


        })
        .catch(function (error) {
            console.log(error);
            return error
        });
}


export async function getConnectFiles(modelId, variantId) {
    var config = {
        method: 'get',
        url: `${process.env.VUE_APP_CONNECT_PROXY}product/model/${modelId}/varient/${variantId}/illustration`,
        headers: {
            'x-api-key': CONNECTAPIKEY
        }
    };
    return axios(config)
        .then(function (response) {
            return response.data;
        })
        .catch(function (error) {
            console.log(error);
            return []
        });
}

export async function getASWOPartsFromDevice(deviceId) {
    var config = {
        method: 'get',
        url: ` ${process.env.VUE_APP_ASWO_PROXY}devicearticles?deviceid=${deviceId}&format=JSON&apikey=${AWSOAPIKEY}`,
        headers: {}
    };

    return axios(config)
        .then(async function (response) {
            const files = await getASWOFiles(deviceId)
            //get files for deviceID add to object
            // console.log(files);
            const parts = Object.keys(response.data).map(key => { return aswoToPart(response.data[key]) });
            // const altPartsPromise = []
            // for (var i = 1; i <= 10; i++) {
            //     altPartsPromise.push(parts[i].partNumber = await getAltParts(parts[i]))

            // };
            // const partswithAlts = await Promise.all(altPartsPromise)
            // parts.map(
            //     part => { if(part.partNumber) }
            //  ) [partswithAlts]
            return { files: files ? files : [], items: parts }
        })
        .catch(function (error) {
            console.log(error);

            //wait 100ms 
            return { files: files ? files : [], items: parts }
        });
}

export async function getASWOPartsFromPart(part) {
    var config = {
        method: 'get',
        url: ` ${process.env.VUE_APP_ASWO_PROXY}articlesearch?articlesearchkeywords=${part}&format=JSON&apikey=${AWSOAPIKEY}`,
        headers: {}
    };

    return axios(config)
        .then(function (response) {
            const parts = Object.keys(response.data).map(key => { return aswoToPart(response.data[key]) });
            return parts
        })
        .catch(function (error) {
            console.log(error);
            return []
        });
}
const waitFor = (ms) => new Promise(r => setTimeout(r, ms));
export async function getConnectPartsFromPart(part) {

    var config = {
        method: 'get',
        url: `${process.env.VUE_APP_CONNECT_PROXY}product/item?query=${part}`,
        headers: {
            'x-api-key': CONNECTAPIKEY
        }
    };

    return axios(config)
        .then(function (response) {
            const parts = response.data.items.map(part => connectToPart(part));
            return parts
        })
        .catch(async function (error) {
            console.log(error);
            console.log("Trying again");
            await waitFor(500)
            return await getConnectPartsFromPart(part)
            // return []
        });

}

export async function getPartsListFromSupplier(listOfModelAndVariants) {
    const promiseList = []
    listOfModelAndVariants.forEach(model => {
        if (model.supplier.name == "ASWO") {
            promiseList.push(getASWOPartsFromDevice(model.modelId))

        }
        if (model.supplier.name == "Connect") {
            promiseList.push(getConnectModelVarients(model.modelId, model.variantId))

        }
    })
    return await Promise.all(promiseList)
}

//sheets interface for WareHouse Stock ???
// const getURL = `https://docs.google.com/spreadsheets/d/e/2PACX-1vQ1Y7LAnLPAVxg-IvENBAZUfPs_nizPPzwVnekaAyTUNMSwVU29raq8HplyeRkiXZGdyAWcI7Cs2OWA/pubhtml`
// async function fetchData() {
//     // eslint-disable-next-line no-unused-vars
//     const data = await axios.get(getURL)
//         .then(response => {
//             const entry = response.data.feed.entry
//             this.records = (entry.length / this.COLUMNS) - 1
//             for (let i = 0; i < this.COLUMNS; i++) {
//                 this.headers.push(entry[i].content.$t)
//             }
//             for (let i = this.headers.length; i < entry.length; i += this.COLUMNS) {
//                 const item = {}
//                 for (let j = 0; j < this.headers.length; j++) {
//                     // entry[i].content.$t retrieves the content of each cell
//                     item[this.headers[j]] = entry[i + j].content.$t
//                 }
//                 this.items.push(item)
//             }
//             console.log(this.items);
//         })
//         .catch(error => {
//             console.log(error)
//         })
// }
// fetchData()
//Mapping Response to SiteModel

export async function getAswoFileFromUrl(url) {
    var config = {
        method: 'get',
        responseType: 'blob',
        url: ` ${process.env.VUE_APP_ASWO_DOWNLOAD_PROXY}${url.replace("https://download.aswo.com/", "")}`,
        headers: {}
    };

    return axios(config)
        .then(function (response) {
            // console.log(repsonse);

            return response.data
        })
        .catch(function (error) {
            console.log(error);
            return []
        });

}


export async function getWareHouseDNumbers() {
    var config = {
        method: 'get',
        url: "https://script.google.com/macros/s/AKfycbzmgOEAtra9R3kG0PGLQJR23W_ZQ_SRT0iKGg9LNlMoT1hop5sIAU9Ds1rvLO3P8Gt7Rw/exec?path=Total Live Stock"
    };
    return await axios(config).then((onfulfilled, onRejected) => {
        if (onfulfilled.data != undefined) {

            if (onfulfilled.data !== "Error!") {
                return onfulfilled.data;
            }
        }
        return ""
    })
        .catch(err => {
            console.warn(err.response.data ? err.response.data?.status : err.response.status);;
            return ""
        })
}